export enum Role {
  Reader = 'reader',
  LimitedReader = 'limited-reader',
  Admin = 'admin',
  LimitedAdmin = 'limited-admin',
  Credentialing = 'credentialing',
  LimitedCredentialing = 'limited-credentialing',
}

export const UserRoleLabel: ObjectType<string> = {
  [Role.Admin]: 'Admin',
  [Role.Reader]: 'User',
  [Role.Credentialing]: 'Credentialing',
  [Role.LimitedReader]: 'Limited User',
  [Role.LimitedAdmin]: 'Limited Admin',
  [Role.LimitedCredentialing]: 'Limited Credentialing',
};
